export default Object.freeze({
  app: {
    uiVersion: 'app_ui_version',
    providers: 'app_providers',
    extraRoutes: 'app_extra_routes',
    extraPublicRoutes: 'app_extra_public_routes',
    extraRootRoutes: 'app_extra_root_routes',
    rootComponent: 'app_root_component',
    rootAssetsComponent: 'app_root_assets_component',
    layout: 'app_layout',
  },
  assets: {
    list: {
      empty: 'assets_list_empty',
    },
    navigation: {
      assets: 'assets_navigation_assets',
      assetTypes: 'assets_navigation_asset_types',
      assetCategories: 'assets_navigation_asset_categories',
      assetClusters: 'assets_navigation_asset_clusters',
      projects: 'assets_navigation_asset_projects',
      serviceTickets: 'assets_navigation_service_tickets',
      basket: 'assets_navigation_basket',
    },
    details: {
      dropZoneHandler: 'assets_details_drop_zone_handler',
      dropZoneEnabled: 'assets_details_drop_zone_enabled',
      cardActions: 'assets_details_card_actions',
      actions: 'assets_details_actions',
      fileActionsExtra: 'assets_details_file_actions_extra',
      contentElement: 'assets_details_content_element',
      providers: 'assets_details_providers',
      contentsExtraColumns: 'assets_details_contents_extra_columns',
      contentsFileItem: 'assets_details_contents_file_item',
      contentsSortFiles: 'assets_details_contents_sort_files',
      contentsDragAndDropEnabled:
        'assets_details_contents_drag_and_drop_enabled',
      contentsShouldRenderChildrenCount:
        'assets_details_contents_should_render_children_count',
    },
    contextBar: {
      imageStyle: 'assets_context_var_image_style',
    },
    qr: {
      style: 'assets_qr_code_style',
    },
    actions: {
      label: 'assets_actions_label',
    },
  },
  navbar: {
    content: {
      before: 'navbar_content_before',
      after: 'navbar_content_after',
    },
    items: 'navbar_items',
    extraItems: 'extra_items',
    usersTitle: 'navbar_items_users_title',
    myDiskTitle: 'navbar_items_my_disk_title',
    reportsTitle: 'navbar_items_reports_title',
    settingsTitle: 'navbar_items_my_settings_title',
    itemsOrder: 'navbar_items_order',
    actions: 'navbar_actions',
    defaultActions: 'navbar_default_actions',
    actionsVisibility: 'navbar_actions_visibility',
  },
  reports: {
    actions: {
      save: 'reports_actions_save',
    },
    table: {
      title: 'report_table_title',
      columns: 'reports_table_columns',
    },
    filters: {
      defaultEnabled: 'reports_filters_default_enabled',
    },
    providers: 'reports_providers',
    multiActions: 'reports_multi_actions',
    createItemActions: 'reports_create_item_actions',
    extraActions: 'reports_extra_actions',
    extraItemActions: 'reports_extra_item_actions',
    itemActions: 'reports_item_actions',
    itemLinkedAttributes: 'reports_item_linked_attributes',
    typeAttributes: 'reports_item_type_attributes',
    serviceRequestDeviceAttributes: 'reports_service_request_device_attributes',
  },
  directories: {
    availableTypes: 'available_directory_types',
    contextualViewModelEnabled: 'contextual_view_mode_enabled',
    defaultSortableField: 'directories_default_sortable_field',
    defaultSortableDirection: 'directories_default_sortable_direction',
  },
  users: {
    list: {
      extraColumns: 'users_list_extra_columns',
      extraFilters: 'users_list_extra_filters',
    },
    form: {
      extraFields: 'users.form.extra_fields',
      extraFieldsModern: 'users.form.extra_fields_modern',
      availableRoles: 'users.form.available_roles',
      serviceTicketsManagerField: 'users.form.service_tickets_manager_field',
    },
    labels: {
      users: 'Users',
      groups: 'Groups',
    },
    extraCrudViews: 'users_extra_crud_views',
    documentation: {
      path: 'users_api_documentation.path',
    },
  },
  groups: {
    table: {
      columns: 'groups_table_columns',
    },
    form: {
      extraFields: 'groups_form_extra_fields',
    },
  },
  components: {
    crudViews: 'components_crud_views',
  },
  settings: {
    extraCrudViews: 'settings_extra_crud_views',
    defaultTab: 'settings_default_tab',
  },
  feedback: {
    detailsComponent: 'feedback_details_component',
    attributes: 'feedback_attributes',
  },
  serviceTickets: {
    extraFilters: 'service_tickets.extra_filters',
  },
  intelligenceLayer: {
    initialValues: 'intelligence_layer.initial_values',
    fieldComponent: 'intelligence_layer.field.component',
    fieldComponentModern: 'intelligence_layer.field.component_modern',
  },
  topBar: {
    links: {
      assets: 'top_bar_links_assets',
      files: 'top_bar_links_files',
      filesLabel: 'top_bar_links_files_label',
    },
    extraLinks: 'top_bar_links_extra_links',
  },
  deviceGroups: {
    table: {
      columns: 'device_groups_table_columns',
    },
  },
  deviceTypes: {
    form: {
      titleOrder: 'device_types_form_title_order',
    },
    devices: {
      defaultFilters: 'device_types_devices_default_filters',
    },
  },
  device: {
    detailsTitle: 'device_details_title',
    detailsContextBarTitle: 'device_details_context_bar_title',
    newDeviceDefaultValues: 'device_new_device_default_values',
    newDeviceRequiredFields: 'device_new_device_required_fields',
  },
  location: {
    trackersToggleEnabled: 'location_trackers_toggle_enabled',
    trackersViewEnabled: 'location_trackers_view_enabled',
    drawer: 'location_view_drawer',
    traces: 'location_view_traces',
    navigationTitle: 'location_view_navigation_title',
    navigationIcon: 'location_view_navigation_icon',
  },
  composites: {
    labelPlural: 'app.components.label_plural',
  },
  projects: {
    labelPlural: 'app.projects.label_plural',
  },
});
